import { completeLesson } from "./course";
import {message} from 'antd';

//ThinkAloud

export function startThinkaloud(){
  return {
    type: 'START_THINKALOUD'
  }
}

export function queryLines(lineData){
  return (dispatch, getState) => {
    const { lineOrder } = getState().thinkaloud;

    for(let i=0; i < lineData.length; i++){
      const line = lineData[i], lineNum = i;

      for(let i=0; i < line.order.length; i++){
        if(line.order[i] === lineOrder){
          dispatch ({ type: 'SELECT_LINE', activeLine: lineNum });
          return
        }
      }
    }
    dispatch ({ type: 'END_THINKALOUD' });
    message.success("ThinkAloud Complete");
    dispatch(completeLesson())
  }
}

export function nextLine(){
  return {
    type: 'NEXT_LINE'
  }
}

export function endThinkaloud(){
  return {
    type: 'END_THINKALOUD'
  }
}



// WEBPACK FOOTER //
// ./src/actions/thinkAloud.js